import { StarFilled } from '@ant-design/icons';
import { Flex } from 'antd';
import { FC } from 'react';

interface StarRatingProps {
  value: number;
  onChange: (value: number) => void;
}

export const StarRating: FC<StarRatingProps> = ({ value, onChange }) => (
  <Flex gap={8}>
    {[1, 2, 3, 4, 5].map(star => (
      <StarFilled
        key={star}
        onClick={() => onChange(star)}
        style={{
          cursor: 'pointer',
          fontSize: 20,
          color: star <= value ? '#D8BD14' : '#FFFFFF1F',
          width: 36,
          height: 36,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: 4,
          padding: 8,
          background: star <= value ? '#AD6B0026' : '#FFFFFF2E',
        }}
      />
    ))}
  </Flex>
);
